export const guides = [
  {
    slug: "choisir-vitrage",
    title: "Comment choisir le type de vitrage ?",
    excerpt:
      "Conseils pour sélectionner le vitrage adapté : sécurité, isolation et esthétique pour vos vitrines et menuiseries.",
    image: "https://images.unsplash.com/photo-1489515217757-5fd1be406fef",
    sections: [
      {
        title: "Sécurité et résistance",
        body:
          "Le vitrage feuilleté ou sécurit limite les risques d’effraction et protège les vitrines commerciales. Il est recommandé pour les locaux sensibles (tabac, boutiques, commerces).",
      },
      {
        title: "Isolation thermique & acoustique",
        body:
          "Le double vitrage améliore le confort intérieur et réduit les pertes d’énergie. Nous analysons vos besoins pour combiner sécurité et isolation.",
      },
      {
        title: "Esthétique & visibilité",
        body:
          "Pour les vitrines, la transparence et la finition sont essentielles. Nos équipes proposent des solutions adaptées à votre image de marque.",
      },
    ],
  },
  {
    slug: "pose-renovation",
    title: "Pose en rénovation : étapes, avantages, conseils",
    excerpt:
      "Tout comprendre sur la pose en rénovation : préparation, étapes clés et bonnes pratiques pour vos projets alu/métal.",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e",
    sections: [
      {
        title: "Diagnostic et prise de cotes",
        body:
          "Nos artisans réalisent un diagnostic complet avant la pose : accessibilité, état du support et contraintes techniques.",
      },
      {
        title: "Dépose et préparation",
        body:
          "Nous sécurisons l’espace, retirons l’ancien équipement et préparons les supports pour une pose durable.",
      },
      {
        title: "Finitions et contrôle",
        body:
          "Les réglages et finitions garantissent une étanchéité et une solidité optimales. Nous validons chaque point avec vous.",
      },
    ],
  },
  {
    slug: "types-de-pose",
    title: "Types de pose : neuf, rénovation, remplacement",
    excerpt:
      "Comparatif des différentes méthodes de pose pour portes, fenêtres, rideaux métalliques et automatismes.",
    image: "https://images.unsplash.com/photo-1502005097973-6a7082348e28",
    sections: [
      {
        title: "Pose en neuf",
        body:
          "Idéale pour les constructions neuves ou les extensions, la pose en neuf maximise les performances et l’intégration esthétique.",
      },
      {
        title: "Pose en rénovation",
        body:
          "La rénovation conserve une partie du bâti existant tout en modernisant vos menuiseries et équipements.",
      },
      {
        title: "Remplacement partiel",
        body:
          "Nous adaptons la solution en fonction de vos contraintes techniques et budgétaires, avec un impact minimal sur l’activité.",
      },
    ],
  },
  {
    slug: "profile-reho",
    title: "Profilé REHO : performances et applications",
    excerpt:
      "Focus sur les profilés REHO : robustesse, finitions et usages pour vos projets aluminium.",
    image: "https://images.unsplash.com/photo-1680866362357-d8192e20a7dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxhbHVtaW51bSUyMHByb2ZpbGUlMjBleHRydXNpb258ZW58MHx8fHwxNzcxNDM1MzIwfDA&ixlib=rb-4.1.0&q=85",
    sections: [
      {
        title: "Pourquoi REHO ?",
        body:
          "Les profilés REHO offrent une excellente rigidité, une finition premium et une grande résistance aux contraintes extérieures.",
      },
      {
        title: "Applications possibles",
        body:
          "Façades, menuiseries aluminium, vitrines sécurisées ou éléments architecturaux : nous intégrons les profilés REHO selon votre besoin.",
      },
      {
        title: "Conseils de mise en œuvre",
        body:
          "Nos équipes assurent la pose et les réglages pour garantir performance thermique, sécurité et esthétique.",
      },
    ],
  },
];
